module.exports = __webpack_public_path__ + "img/神经网络计算-下层.551899b4.png";